﻿import { ensureCountUp } from "@js/core/loaders/vendors";

export async function initCountUpCounters() {
    const counters = Array.from(document.querySelectorAll(".num"));
    if (!counters.length) return;

    const countUpLib = await ensureCountUp();
    const CountUp = countUpLib?.CountUp;
    if (!CountUp) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const el = entry.target;
            if (el.dataset.counted === "1") {
                obs.unobserve(el);
                return;
            }

            const target = Number(el.dataset.count || "0");
            const counter = new CountUp(el, target, {
                duration: 2,
                separator: "."
            });

            if (!counter.error) {
                counter.start();
                el.dataset.counted = "1";
            } else {
                console.error(counter.error);
            }

            obs.unobserve(el);
        });
    }, {
        threshold: 0.6
    });

    counters.forEach((el) => {
        el.dataset.counted = "0";
        observer.observe(el);
    });
}